import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Divider } from '../Divider';

function Separator(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Separator'),
      _useContextSystem$mb = _useContextSystem.mb,
      mb = _useContextSystem$mb === void 0 ? 3 : _useContextSystem$mb,
      _useContextSystem$mt = _useContextSystem.mt,
      mt = _useContextSystem$mt === void 0 ? 3 : _useContextSystem$mt,
      otherProps = _objectWithoutProperties(_useContextSystem, ["mb", "mt"]);

  return /*#__PURE__*/React.createElement(Divider, Object.assign({}, otherProps, {
    mb: mb,
    mt: mt,
    ref: forwardedRef
  }));
}

export default contextConnect(Separator, 'Separator');